var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M28,26H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H28a5.006,5.006,0,0,1,5,5V21A5.006,5.006,0,0,1,28,26ZM13,8v10.1l8.475-5.159Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c504cf335af812b9522346b6b9ca4223.svg";
export { ForwardRef as ReactComponent };